import React from 'react';

export default class Page9 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt w-100">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <p><strong> Strength/Development Summary</strong></p>
                                            <div className="mobile-scroll md-lg-scroll">
                                                <div align="center">

                                                    <div className="analysisbg">

                                                        <div className="analysisleftbox">
                                                            <div className="analysistexboxleft1">
                                                                <textarea className="analysistexboxwdt"
                                                                          name="Strength"
                                                                          value={this.props.pageData?.V?.Strength}
                                                                          onChange={this.props.handleChangePageData('V')}/>
                                                            </div>
                                                            <div className="analysistexboxleftcommon">
                                                                <textarea className="analysistexboxwdt"
                                                                          name="Strength"
                                                                          value={this.props.pageData?.S?.Strength}
                                                                          onChange={this.props.handleChangePageData('S')}/>
                                                            </div>
                                                            <div className="analysistexboxleftcommon">
                                                                <textarea className="analysistexboxwdt"
                                                                          name="Strength"
                                                                          value={this.props.pageData?.P?.Strength}
                                                                          onChange={this.props.handleChangePageData('P')}/>
                                                            </div>
                                                            <div className="analysistexboxleftcommon">
                                                                <textarea className="analysistexboxwdt"
                                                                          name="Strength"
                                                                          value={this.props.pageData?.O?.Strength}
                                                                          onChange={this.props.handleChangePageData('O')}/>
                                                            </div>
                                                            <div className="analysistexboxleftcommon">
                                                                 <textarea className="analysistexboxwdt"
                                                                           name="Strength"
                                                                           value={this.props.pageData?.R?.Strength}
                                                                           onChange={this.props.handleChangePageData('R')}/>
                                                            </div>
                                                            <div className="analysistexboxleftcommon">
                                                                 <textarea className="analysistexboxwdt"
                                                                           name="Strength"
                                                                           value={this.props.pageData?.T?.Strength}
                                                                           onChange={this.props.handleChangePageData('T')}/>
                                                            </div>
                                                        </div>
                                                        <div className="analysis_middlebox">
                                                            <div className="analysis_middlebxpad_v"></div>
                                                            <div className="analysis_middlebxpad_s"></div>
                                                            <div className="analysis_middlebxpad_p"></div>
                                                            <div className="analysis_middlebxpad_o"></div>
                                                            <div className="analysis_middlebxpad_r"></div>
                                                            <div className="analysis_middlebxpad_t"></div>

                                                        </div>
                                                        <div className="analysisrightbox">

                                                            <div className="analysistexboxright1">
                                                                 <textarea className="analysistexboxwdt"
                                                                           name="Development"
                                                                           value={this.props.pageData?.V?.Development}
                                                                           onChange={this.props.handleChangePageData('V')}/>
                                                            </div>
                                                            <div className="analysistexboxrightcommon">

                                                                 <textarea className="analysistexboxwdt"
                                                                           name="Development"
                                                                           value={this.props.pageData?.S?.Development}
                                                                           onChange={this.props.handleChangePageData('S')}/>
                                                            </div>
                                                            <div className="analysistexboxrightcommon">
                                                                 <textarea className="analysistexboxwdt"
                                                                           name="Development"
                                                                           value={this.props.pageData?.P?.Development}
                                                                           onChange={this.props.handleChangePageData('P')}/>
                                                            </div>
                                                            <div className="analysistexboxrightcommon">
                                                                 <textarea className="analysistexboxwdt"
                                                                           name="Development"
                                                                           value={this.props.pageData?.O?.Development}
                                                                           onChange={this.props.handleChangePageData('O')}/>
                                                            </div>
                                                            <div className="analysistexboxrightcommon">
                                                                 <textarea className="analysistexboxwdt"
                                                                           name="Development"
                                                                           value={this.props.pageData?.R?.Development}
                                                                           onChange={this.props.handleChangePageData('R')}/>
                                                            </div>
                                                            <div className="analysistexboxrightcommon">
                                                                 <textarea className="analysistexboxwdt"
                                                                           name="Development"
                                                                           value={this.props.pageData?.T?.Development}
                                                                           onChange={this.props.handleChangePageData('T')}/>
                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div className="border_subtitle"
                                                 style={{clear:'both', paddingTop:'18px'}}>Step 3: Consider your
                                                strengths and development needs
                                            </div>
                                            <p>Now you’ve identified your stronger and weaker areas think
                                                about how you can capitalise on your strengths and what you
                                                might need to do to improve your weaker areas. Consider the
                                                following questions to help you focus your thoughts:</p>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page8')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.savePageData('Page10')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}